import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MtnaLogger } from '@mtna/core-angular';
import { RdsMngDataProduct } from '@rds/rds-metadata-ts';
import { RdsApiService } from '@rds/shared-api';
import { Observable } from 'rxjs';

/**
 * Represents
 * <https://dev.richdataservices.com/rds/swagger/#/CacheController>
 */
@Injectable({
  providedIn: 'root',
})
export class RdsCacheService {
  /** base url for the service */
  protected get CACHE_URL(): string {
    let apiUrl: string = this.apiService.getApiUrl() || '';
    if (!apiUrl?.endsWith('/app-api')) {
      // Support backwards compatibility
      // The API url should no longer end with '/api',
      // but point to the root of the rds instance.
      apiUrl += '/app-api';
    }
    return `${apiUrl}/cache`;
  }

  /** url with ID of the selected catalog */
  protected get CATALOG_ID_URL(): string {
    return `${this.CACHE_URL}/${this.apiService.getCatalogId()}`;
  }

  /** url with ID of the selected data product */
  protected get DATA_PRODUCT_URL(): string {
    return `${this.CATALOG_ID_URL}/${this.apiService.getDataProductId()}`;
  }

  constructor(protected apiService: RdsApiService, protected http: HttpClient, protected logger: MtnaLogger) {}

  /**
   * Administrative end point to expire the cache of a particular data product and flag it as not needing to be cached.
   */
  disableDataProductCache(): Observable<RdsMngDataProduct> {
    return this.http.post<RdsMngDataProduct>(`${this.DATA_PRODUCT_URL}/disable`, {});
  }

  /**
   * Administrative end point to expire the cache of a particular data product and flag it as needing to be cached.
   * By default data products will be cached,
   * so this is only necessary to re-enable data products that have previously had their caching disabled.
   */
  enableDataProductCache(): Observable<RdsMngDataProduct> {
    return this.http.post<RdsMngDataProduct>(`${this.DATA_PRODUCT_URL}/enable`, {});
  }

  /**
   * Administrative end point to manually force an expiration of all the cached files of specific data product.
   */
  expireDataProductCache(): Observable<RdsMngDataProduct> {
    return this.http.delete<RdsMngDataProduct>(`${this.DATA_PRODUCT_URL}`);
  }
}
